import autoResizeTextArea from "./autoResizeTextArea"
import onLimitedInputChanged from "./onLimitedInputChanged"
import "styles/components/forms/index.scss"

const ajaxForms = {}

const formatErrorMsg = msgList =>
  msgList.map(msg => `<li class="form__message--error">${msg}</li>`).join("")

async function getRedirectUrlAfterLogin({ formEl }) {
  const { csrfTokenName, csrfTokenValue } = __PAGE_VARS__
  const url = "/actions/members-functions/default/memberpage"
  let redirectUrl = null

  try {
    redirectUrl = await $.ajax({
      url,
      type: "POST",
      data: {
        [csrfTokenName]: csrfTokenValue,
        emailOrUsername: formEl.loginName.value
      },
      dataType: "json"
    })

    return redirectUrl
  } catch (error) {
    console.error(url, error)
    return { error }
  }
}

const onRequestSuccess = ({ formEl, response, redirectUrl }) => {
  console.log(formEl, response, redirectUrl)
  const { success, errors, error, errorCode = 200 } = response
  let errorList = []
  let errorListNodes = ""

  if (success) {
    console.info(success, response.id, response.returnUrl)
    const successMsgEl =
      formEl.querySelector(".alert-success") ||
      formEl.parentNode.querySelector(".alert-success")

    if (successMsgEl) {
      successMsgEl.innerHTML = successMsgEl.dataset.defaultmsg
      successMsgEl.classList.add("form__successMsg--visible")
    }

    formEl
      .querySelectorAll(".input__messages--error")
      .forEach(el => el.classList.add("hidden"))

    formEl.classList.add("form--success")

    if (formEl.dataset.warnbeforequit) {
      formEl.classList.remove("form--unsaved")
      formEl.classList.add("form--saved")
    }

    if (redirectUrl) {
      window.location = redirectUrl
    } else if (formEl.dataset.callback) {
      __PAGE_VARS__[formEl.dataset.callback]({ formEl, response })
    }
  } else {
    if (errors) {
      errorList = Object.keys(errors)
      errorList.forEach((fieldName, index) => {
        // Errors key returned from backend doesnt match the name of the input for matrix type
        // to handle this inconsistency customs name/key is used to match all the cases
        const inputEl =
          formEl.querySelector(`input[name="${fieldName}"]`) ||
          formEl.querySelector(`input[name="fields[${fieldName}][value]"]`) ||
          formEl.querySelector(`input[data-errorkey="${fieldName}"]`)

        console.log(
          "\n",
          fieldName,
          `[name="fields[${fieldName}][value]"]`,
          inputEl,
          errors[fieldName]
        )

        if (inputEl) {
          errorListNodes += `<li>${errors[fieldName].join(" ")}</li>`

          const errorref =
            inputEl.dataset.errorref || "_" + Date.now() + "-" + index
          inputEl.dataset.errorref = errorref
          ajaxForms[formEl.id].errors[errorref] = inputEl

          const errorMsgEl = formEl.querySelector(`#${errorref}`)
          let formatedErrorMsg = formatErrorMsg(errors[fieldName])

          if (errorMsgEl) {
            errorMsgEl.innerHTML = formatedErrorMsg
            errorMsgEl.classList.remove("alert-light", "hidden")
          } else {
            formatedErrorMsg = `
              <ul id="${errorref}" class="alert alert-danger input__messages--error input-${fieldName}__messages--error">
                ${formatedErrorMsg}
                <li>
                  <button type="button" data-ref="${errorref}" class="btn btn-danger icon icon_arrowDownCircle form__btn--nextError"></button>
                </li>
              </ul>`
            inputEl.insertAdjacentHTML("afterend", formatedErrorMsg)
          }

          inputEl.classList.add("form__input--error")
        } else {
          errorListNodes += `<li>${errors[fieldName].join(" ")}</li>`
        }
      })

      errorListNodes =
        errorListNodes !== ""
          ? `<ul class="error-list">${errorListNodes}</ul>`
          : null
    }

    showGeneralErrorMsg(formEl, error, errorList, errorListNodes, errorCode)
  }

  formEl.classList.remove("form--busy")
}

const showGeneralErrorMsg = (
  formEl,
  error,
  errorList,
  errorListNodes,
  errorCode
) => {
  formEl.classList.add("form--error", `form--error--${errorCode}`)

  const generalErrorMsgEl = formEl.querySelector(".form__errorMsg")
  if (generalErrorMsgEl) {
    const errorMsg = `${generalErrorMsgEl.dataset.defaultmsg} ${error ||
      errorListNodes}`
    generalErrorMsgEl.innerHTML = `${errorMsg} <button type="button" id="${
      formEl.id
    }--errorCount" class="btn form__btn--nextError">${
      errorList ? errorList.length : ""
    }</button>`

    showInViewport(generalErrorMsgEl)
  }
}

const showInViewport = el => {
  $([document.documentElement, document.body]).animate(
    {
      scrollTop: $(el).offset().top - window.innerHeight * 0.5
    },
    200
  )
}

const onClickNextErrorButton = ({ btnEl, formEl }) => {
  const nextInput =
    [...formEl.querySelectorAll(".form__input--error")].filter(
      ({ dataset }) => dataset.errorref !== btnEl.dataset.ref
    )[0] || formEl.querySelector('button[type="submit"]')

  showInViewport(nextInput)
}

const onErronedInputChanged = ({ inputEl, formId }) => {
  const errorMsgEl = inputEl.parentNode.querySelector(".input__messages--error")
  inputEl.classList.remove("form__input--error")
  errorMsgEl.classList.add("hidden")

  if (ajaxForms[formId]) {
    ajaxForms[formId].errors[inputEl.dataset.errorref] = false

    const errorCount = Object.values(ajaxForms[formId].errors).filter(e => e)
    document.getElementById(`${formId}--errorCount`).innerHTML =
      errorCount.length
    if (errorCount.length === 0) {
      ajaxForms[formId].el.classList.remove("form--busy", "form--error")
    }
  }
}

const submitForm = ({ formEl, redirectUrl = null }) => {
  // Data validation is done on server side
  formEl.classList.add("form--busy")

  const successMsgEl =
    formEl.querySelector(".alert-success") ||
    formEl.parentNode.querySelector(".alert-success")

  if (successMsgEl) {
    successMsgEl.classList.remove("form__successMsg--visible")
  }

  // Ensure that all url input start with https, or a validation error will be throw by the server
  formEl.querySelectorAll('input[type="url"]').forEach(el => {
    if (el.value !== "" && !/^(.*?:\/\/)/i.test(el.value)) {
      el.value = `https://{el.value}`
    }
    el.value = el.value.replace(/^.*:\/\//i, "https://")
  })

  // For forms with mandatory fields, check if all the required fields are not empty
  const requiredFieldList = [...formEl.querySelectorAll("[required]")]
  if (formEl.dataset.hasmandatoryfields === "1" && requiredFieldList[0]) {
    const requiredErrors = requiredFieldList.reduce((a, el) => {
      console.log(el.id, el.nodeName.toLowerCase())
      let fieldIsMissing = false
      switch (el.nodeName.toLowerCase()) {
        case "input":
          fieldIsMissing = el.value === ""
          break
        case "select":
          fieldIsMissing = el.options[el.selectedIndex].value === ""
          console.log(el.options[el.selectedIndex].value, fieldIsMissing)
          break
      }

      if (fieldIsMissing) {
        const fieldName = (
          el.parentNode.querySelector("label") || { innerText: "" }
        ).innerText
        a[el.name] = [
          `${fieldName}: ${__PAGE_VARS__.translations.requiredField}`
        ]
      }

      return a
    }, {})
    if (Object.keys(requiredErrors)[0]) {
      onRequestSuccess({ formEl, response: { errors: requiredErrors } })
      return
    }
  }

  if (formEl.classList.contains("form--addProject")) {
    const eventIdEl = formEl.elements["fields[isRegisteredFor]"]
    console.log(eventIdEl)
    if (eventIdEl === null) {
      showGeneralErrorMsg(
        formEl,
        null,
        null,
        "Impossible de sauvegarder le projet pour le moment, merci de nous contacter par courriel.",
        500
      )
      return
    }
  }

  const requestOptions = {
    url: "/",
    dataType: "json",
    success: (response, textStatus, jqXHR) => {
      console.log("success", response, textStatus, jqXHR)
      onRequestSuccess({ formEl, response, redirectUrl })
    }
  }

  if (formEl.enctype === "multipart/form-data") {
    requestOptions.enctype = "multipart/form-data"
    requestOptions.processData = false
    requestOptions.contentType = false
    requestOptions.data = new FormData(formEl)
  } else {
    requestOptions.data = $(formEl).serialize()
  }

  $.post(requestOptions).always((response, textStatus, jqXHR) => {
    const { status, responseText } = response
    // BUG: exception for project submission return a 500 error, when an image is submited in the form, even if the entry is properly saved
    // IMPROVMENT: find the origin of the error and implement better error handling
    console.warn(response)
    if (status === 500) {
      if (responseText.match(/(“assets.*[jpe?g|png|gif]”)/gi))
        onRequestSuccess({ formEl, response: { success: true }, redirectUrl })
      else {
        showGeneralErrorMsg(
          formEl,
          null,
          null,
          "Impossible de sauvegarder le projet pour le moment, merci de réessayer ultérieurement",
          500
        )
        formEl.classList.remove("form--busy")
      }
    } else if ([400].includes(status)) {
      onRequestSuccess({ formEl, response })
    }
  })
}

const initAjaxForm = el => {
  el.classList.add("form--ajaxEnabled")

  // Errors key returned from backend doesnt match the name of the input for matrix type
  // to handle this inconsistency, customs name/key is used to match all the cases
  const formId = el.id
  el.querySelectorAll("input").forEach((inputEl, index) => {
    const inputName = `${el.name}`.replace(/[\[\]]/g, "_")
    inputEl.setAttribute("data-errorref", `${formId}-${inputName}-${index}`)
  })

  ajaxForms[formId] = {
    id: formId,
    el,
    errors: {}
  }

  $(el).submit(event => {
    event.preventDefault()

    const { target } = event
    target.classList.remove("form--error", "form--success")

    // TODO: normalize redirectUrl param name > use redirectaftersuccess
    let redirectUrl =
      el.dataset.redirectafterlogin || el.dataset.redirectaftersuccess || "/"

    console.log("redirectUrl", redirectUrl, el)

    switch (redirectUrl) {
      case "memberPage":
        // Request to get redirect url must be done before user login
        // because, once logged, the csrf token will change
        getRedirectUrlAfterLogin({ formEl: el }).then(response => {
          const locale = __PAGE_VARS__.locale.split("-")[0]
          if (response.success && response.urls[locale]) {
            redirectUrl = response.urls[locale]
            redirectUrl =
              redirectUrl[0] === "/" ? redirectUrl : `/${redirectUrl}`
            redirectUrl = `/${locale}${redirectUrl}`
          }

          submitForm({ formEl: el, redirectUrl })
        })
        break
      case "no-redirect":
        submitForm({ formEl: el })
        break
      default:
        submitForm({ formEl: el, redirectUrl })
        break
    }
  })
}

const Forms = ({ el, params }) => {
  const formId = el.id || `ajaxForm--${Date.now()}`
  el.id = formId

  initAjaxForm(el)
  ;[...el.querySelectorAll("input[maxlength]")].forEach(inputEl => {
    const helpElId = inputEl.getAttribute("aria-describedby")
    const limitEl = el.querySelector(`#${helpElId}`)
    if (limitEl) {
      const maxLength = inputEl.getAttribute("maxlength")
      $(inputEl).on("change paste keyup", ({ target }) =>
        onLimitedInputChanged({ inputEl, limitEl, maxLength })
      )
      onLimitedInputChanged({ inputEl, limitEl, maxLength })
    }
  })

  el.querySelectorAll("textarea").forEach(textareaEl => {
    if (textareaEl.classList.contains("autoresize")) {
      autoResizeTextArea(textareaEl)
    }

    const helpElId = textareaEl.getAttribute("aria-describedby")
    const limitEl = el.querySelector(`#${helpElId}`)
    const maxLength = textareaEl.getAttribute("maxlength")
    if (limitEl && maxLength) {
      $(textareaEl).on("change paste keyup focus", ({ target }) =>
        onLimitedInputChanged({ inputEl: textareaEl, limitEl, maxLength })
      )
      onLimitedInputChanged({ inputEl: textareaEl, limitEl, maxLength })
    }
  })
  $(el).on("change paste keyup focus", "textarea.autoresize", ({ target }) => {
    autoResizeTextArea(target)
  })

  $(el).on("change paste keyup", ".form__input--error", ({ target }) =>
    onErronedInputChanged({ inputEl: target, formId })
  )

  $(el).on("click", ".form__btn--nextError", ({ target }) =>
    onClickNextErrorButton({ btnEl: target, formEl: el })
  )

  return el
}

export { Forms as initForm }
